import { Card, Col, Form, Row, Typography } from "antd";
import { ChangeEvent, FunctionComponent, KeyboardEvent, useEffect, useState } from "react";
import "./card-portfolio.scss";
import FormItemInput from "../../../../../components/form-input/FormInput";
import { useForm } from "antd/es/form/Form";
import { SearchOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

type CardPortfolioProps = {
  listDataPortfolio: any;
  setPortfolioIdValue: (value: number | string) => void;
};

const CardPortfolio: FunctionComponent<CardPortfolioProps> = ({
  listDataPortfolio,
  setPortfolioIdValue,
}) => {
  const { t } = useTranslation();
  const [listPortfolio, setListPortfolio] = useState<any>();
  const [rowActive, setRowActive] = useState(0);
  const [searchValue, setSearchValue] = useState<string>("");
  const [isFirstTime, setIsFirstTime] = useState(true);

  const [form] = useForm();

  // Filter Search Department

  // Conversion function
  const removeAccents = (str: string) =>
    str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  // Convert to unaccented name
  const listDataPortfolioWithoutAccents = listDataPortfolio?.map((item: any) => ({
    ...item,
    normalizedName: item.name ? removeAccents(item.name.toLowerCase()) : "",
  })) || [];

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchValue(value);
    if (value.length === 0) {
      setListPortfolio(listDataPortfolio);
    } else {
      const normalizedValue = removeAccents(value.toLowerCase());
      const searchData = listDataPortfolioWithoutAccents.filter((item: any) =>
        item.normalizedName?.includes(normalizedValue)
      );
      setListPortfolio(searchData);
    }
  };

  const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      setRowActive(0);
      if (searchValue.length > 0) {
        const normalizedValue = removeAccents(searchValue.toLowerCase());
        const searchData = listDataPortfolioWithoutAccents.filter((item: any) =>
          item.normalizedName?.includes(normalizedValue)
        );
        setListPortfolio(searchData);
      }
    }
  };

  const handleSubmitSearch = () => {
    setRowActive(0);
    if (searchValue.length > 0) {
      const normalizedValue = removeAccents(searchValue.toLowerCase());
      const searchData = listDataPortfolioWithoutAccents.filter((item: any) =>
        item.normalizedName?.includes(normalizedValue)
      );
      setListPortfolio(searchData);
    }
  };

  const handleActiveRow = (item: any, index: number) => {
    setPortfolioIdValue(item.id);
    setRowActive(index);
  };

  // useEffect
  useEffect(() => {
    if (listDataPortfolio?.length > 0 && isFirstTime) {
      setListPortfolio(listDataPortfolio);
      setPortfolioIdValue(listDataPortfolio[0]?.id);
      setIsFirstTime(false);
    }
  }, [listDataPortfolio]);

  return (
    <>
      <Card className="card-portfolio" bordered={false}>
        <div className="header-portfolio-card">
          <div className="card-portfolio-title flex mb-1">
            <Typography.Title level={4}>{t("Danh sách Danh mục", "Danh sách Danh mục")}</Typography.Title>
          </div>
          <div className="card-filter">
            <Form name="portfolio-filter-form" form={form}>
              <Row gutter={[{ xs: 8, xl: 24, md: 16 }, 12]}>
                <Col span={24}>
                  <FormItemInput
                    placeholder={t("Nhập tên để tìm kiếm", "Nhập tên để tìm kiếm")}
                    value={searchValue}
                    onChange={handleChangeInput}
                    onKeyPress={handleSearch}
                    afterPrefixIcon={
                      <SearchOutlined onClick={handleSubmitSearch} />
                    }
                  />
                </Col>
              </Row>
            </Form>
          </div>
        </div>
        <div className="body-card">
          {listPortfolio?.map((item: any, index: number) => {
            return (
              <div
                key={item.id || index}
                className={`portfolio-item ${
                  rowActive === index ? `active` : ""
                }`}
                onClick={() => handleActiveRow(item, index)}
              >
                <Typography.Text className="row-index">
                  {index + 1}.
                </Typography.Text>
                <Typography.Text className="portfolio-name">
                  {item.name}
                </Typography.Text>
              </div>
            );
          })}
        </div>
      </Card>
    </>
  );
};

export default CardPortfolio;
